import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import { useState } from "react";
import { formatNumberWithCommas } from "../../utils/format-number";

const headers = [
  {
    key: "purchase_order",
    name: "Purchase Order No",
  },
  {
    key: "supplier_name",
    parent: "supplier",
    name: "Supplier Name",
  },
  {
    key: "purchase_date",
    name: "Purchase Date",
  },
  {
    key: "total",
    name: "Total Amount",
    render: (value) => formatNumberWithCommas(value),
  },
  {
    key: "currency_type",
    name: "currency",
  },
  {
    key: "status",
    name: "Status",
  },
];

const detailPopupHeaders = [
  {
    key: "purchase_id",
    name: "Purchase Order ID",
  },
  {
    key: "supplier_name",
    parent: "supplier",
    name: "Supplier Name",
  },
  {
    key: "purchase_date",
    name: "Purchase Date",
  },
  {
    key: "currency_type",
    name: "Currency Type",
  },
  {
    key: "total",
    name: "Total Amount",
    render: (value) => formatNumberWithCommas(value),
  },
  {
    key: "remark",
    name: "Remark",
  },
];

const detailPopupTableHeaders = [
  {
    key: "product_name",
    parent: "product",
    name: "Product Name",
  },
  {
    key: "unit_name",
    parent: "unit",
    name: "Unit",
  },
  {
    key: "quantity",
    name: "Quantity",
  },
  {
    key: "price",
    name: "Price",
    render: (value) => formatNumberWithCommas(value),
  },
  {
    key: "total_amount",
    name: "Total",
    render: (value) => formatNumberWithCommas(value),
  },
];

const PurchaseOrderList = () => {
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const currentPath = location.pathname;

  const handleSearch = (value) => {
    const trimmed = value.trim();
    if (trimmed.length > 0) {
      setSearchValue(trimmed);
      setQuery({ search: trimmed });
    } else {
      setSearchValue("");
      setQuery({});
    }
  };

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/purchaseOrder",
    defaultQuery: "status=Pending&status=PARTIAL_ARRIVED&status=ARRIVED",
    included: false,
  });

  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Purchase Order List"
      data={data}
      headers={headers}
      detailPopupTitle="Purchase Order Information"
      detailPopupHeaders={detailPopupHeaders}
      detailPopupTableHeaders={detailPopupTableHeaders}
      detailPopupTableKey="purchaseOrderDetails"
      detailFetchPath="/purchaseOrder"
      idKey="purchase_id"
      endPoint="/purchaseOrder"
      setCurrentPage={setCurrentPage}
      hasSearch
      hasCreate
      hasActions
      module="Purchase"
      subModule="Purchase Order List"
      createPath={`/purchase/purchase-order/list/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      reload={reload}
      removeEdit={true}
      setQuery={setQuery}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
    />
  );
};

export default PurchaseOrderList;
